import React from "react";
import classNames from "classnames";

type Props = {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
};

const Toggle: React.FC<Props> = ({ checked, onChange, disabled }) => {
  const handleClick = () => {
    if (disabled) return;
    onChange(!checked);
  };

  return (
    <button
      type="button"
      className={classNames("ui-switch", {
        "ui-switch--checked": checked,
        "ui-switch--disabled": disabled,
      })}
      onClick={handleClick}
      aria-pressed={checked}
    >
      <span className="ui-switch__thumb" />
    </button>
  );
};

export default Toggle;
